<template>
  <div>
  <b-card style="position: relative">
  <filters />
  </b-card>
  <b-card style="position: relative">
    <div v-if="$store.getters['fieldServices.installation.list/isLoading']" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>
    </div>

    <div class="m-2">
      <b-row>
        <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
          <label>{{ $t('Show') }}</label>
          <v-select 
              :value="$store.getters['fieldServices.installation.list/perPage']"
              @input="value => {
                $store.commit('fieldServices.installation.list/updatePerPage', { value })
                $store.dispatch('fieldServices.installation.list/fetchList')
              }"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="$store.getters['fieldServices.installation.list/perPageOptions']"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"/>
          <label>{{ $t('entries') }}</label>
        </b-col>
        <b-col cols="12" md="6">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input 
                :value="$store.getters['fieldServices.installation.list/uniqueIdFilter']"
                @input="value => {
                  $store.commit('fieldServices.installation.list/updateUniqueIdFilter', { value })
                  $store.dispatch('fieldServices.installation.list/fetchList')
                }"
                class="d-inline-block mr-1" 
                :placeholder="$t('FIELD_SERVICES_FILTER_BY_UNIQUE_ID')"
            />
            <b-form-input 
                :value="$store.getters['fieldServices.installation.list/simIdFilter']"
                @input="value => {
                  $store.commit('fieldServices.installation.list/updateSimIdFilter', { value })
                  $store.dispatch('fieldServices.installation.list/fetchList')
                }"
                class="d-inline-block mr-1" 
                :placeholder="$t('FIELD_SERVICES_FILTER_BY_SIM_ID')"
            />
            <b-button 
                v-if="($store.getters['auth/user'].permissions.includes('fieldServices.installation.create'))" 
                variant="primary"
                :to="{ name: 'fieldServices.installation.create' }"
            >
              <span class="text-nowrap">{{ $t('FIELD_SERVICES_CREATE_LABEL')}}</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-table 
      :items="$store.getters['fieldServices.installation.list/list']" 
      :fields="$store.getters['fieldServices.installation.list/tableColumns']"
      class="position-relative" 
      primary-key="id"
      empty-text="No matching records found"
      show-empty
      responsive
      >

      <template #cell(id)="data"> {{ data.index + 1 }} </template>

      <template #cell(actions)="data">

        <b-dropdown 
          class="actionIcon" 
          variant="link" 
          no-caret 
          :right="$store.state.appConfig.isRTL"
          v-if="$store.getters['auth/user'].permissions.includes('fieldServices.installation.show') ||
          $store.getters['auth/user'].permissions.includes('fieldServices.installation.delete')"
        >

          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body"/>
          </template>

          <b-dropdown-item 
            :to="{ name: 'fieldServices.installation.show', params: { id: data.item.id } }"
            v-if="($store.getters['auth/user'].permissions.includes('fieldServices.installation.show'))" 
          >
            <feather-icon icon="EditIcon" />
            <span class="align-middle ml-50">{{ $t('FILED_SERVICES_DETAILS_LABEL') }}</span>
          </b-dropdown-item>

          <b-dropdown-item 
            v-if="($store.getters['auth/user'].permissions.includes('fieldServices.installation.delete'))"
            @click="()=> $store.dispatch('fieldServices.installation.list/delete', data.item)"
          >
            <feather-icon icon="TrashIcon" />
            <span class="align-middle ml-50">{{ $t('FILED_SERVICES_DELETE_LABEL') }}</span>
          </b-dropdown-item>

        </b-dropdown>
      </template>

    </b-table>

    <div class="mx-2 mb-2">
      <b-row>
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
          <span class="text-muted">{{ $store.getters['fieldServices.installation.list/tableMeta'] }}</span>
        </b-col>
        <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination 
              :value="$store.getters['fieldServices.installation.list/currentPage']"
              @input="value => {
                $store.commit('fieldServices.installation.list/updateCurrentPage', { value })
                $store.dispatch('fieldServices.installation.list/fetchList')
              }"
              :total-rows="$store.getters['fieldServices.installation.list/tableTotalRows']"
              :per-page="$store.getters['fieldServices.installation.list/perPage']" 
              first-number 
              last-number
              class="mb-0 mt-1 mt-sm-0" 
              prev-class="prev-item" 
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18"/>
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18"/>
            </template>
          </b-pagination>

        </b-col>
      </b-row>
    </div>
  </b-card>
</div>
</template>

<script>

import { OrbitSpinner } from 'epic-spinners'

import {
  BButton, 
  BCard, 
  BCol,
  BForm,
  BFormGroup, 
  BFormInput,
  BInputGroup, 
  BRow, 
  BAlert, 
  BTabs, 
  BTab, 
  BCardText, 
  BTable, 
  BPagination, 
  BDropdown, 
  BDropdownItem
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import filters from './components/Filters'
import StoreModule from '@/app/fieldServices/installation/ListStoreModule.js'

export default {
  name: 'list',
  components: { 
    filters,
    BRow, 
    BCard, 
    BCol, 
    BAlert, 
    BTable,BPagination,
    BFormGroup, 
    BFormInput, 
    BInputGroup, 
    BForm, 
    BButton, 
    BTabs, 
    BCardText, 
    BTab, 
    vSelect, 
    OrbitSpinner, 
    BDropdown,
    BDropdownItem
  },
  directives: { Ripple },
  setup( props, { root }) {

    const STORE_MODULE = 'fieldServices.installation.list'
    store.registerModule(STORE_MODULE, StoreModule)

    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE)){
        store.unregisterModule(STORE_MODULE)
      }
    })

    store.commit('fieldServices.installation.list/updateRoot', root)
    store.dispatch('fieldServices.installation.list/fetchList')

    return {}

  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.actionIcon>button {
  padding: 0;
}
</style>
